var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invoiceTemplateList.length > 0
    ? _c(
        "div",
        { staticClass: "filter-inline" },
        [
          _c(
            "form-group",
            { attrs: { name: "invoiceTemplate", label: "Invoice Template" } },
            [
              _c("md-input", {
                attrs: { type: "hidden" },
                model: {
                  value: _vm.selectedOption,
                  callback: function ($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption",
                },
              }),
              _c("vue-select", {
                attrs: {
                  "data-testid": "invoice-template",
                  reduce: function (r) {
                    return r
                  },
                  label: "templateName",
                  options: _vm.invoiceTemplateList,
                  searchable: _vm.$root.isDesktop,
                },
                model: {
                  value: _vm.selectedOption,
                  callback: function ($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }